export class PassReset {
    oldPassword: string;
    password: string;
    confirmPassword: string;
}